import React, { Fragment } from "react";
import ReactDOM from "react-dom";
import { useTimeout } from "../../../hooks/use-timeout";
import classes from "./Toast.module.css";
const ToastOverlay = (props) => {
  return (
    <div className={classes.toast}>
      <div className={classes.toast__text}>{props.children}</div>
      <div>
        <button onClick={props.onClick} className={classes["toast__close-btn"]}>
          x
        </button>
      </div>
    </div>
  );
};

export const Toast = (props) => {
  useTimeout(props.close, 2000);
  const portalElement = document.getElementById("toasts-wrapper");

  return (
    <Fragment>
      {ReactDOM.createPortal(
        <ToastOverlay onClick={props.close}>{props.children}</ToastOverlay>,
        portalElement
      )}
    </Fragment>
  );
};
